import React from 'react';
import {
    Typography,
    Box,
    Avatar,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const BlogColumns = () => [
    {
        id: "title",
        label: "Title",
        render: (value, row) => {
            // Show title in default language (en) or first available
            const title = row.title_en || row.title_hy || row.title_ru || 'No title';
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {row.image && (
                        <Avatar
                            variant="rounded"
                            src={row.image}
                            sx={{ width: 56, height: 56 }}
                        />
                    )}
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {title}
                    </Typography>
                </Box>
            );
        }
    },
    {
        id: "views",
        label: "Views",
        render: (value, row) => {
            return (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body2">
                        {value || 0}
                    </Typography>
                </Box>
            );
        }
    },
    {
        id: "created_at",
        label: "Created Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
